import SmartRecycleBinIcon from './component'

export default SmartRecycleBinIcon
